<template>
    <div>
        <top-navbar></top-navbar>
<div>
  

<div class="container-fluid">
  <h6  class="manage-boder pt-2 font1 font-bold1"> <router-link class="decoration" to="/admin/overview"> Home </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" to="/aparment/index"> Apartment List </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" :to="'/aparment/view?id='+customers.idCustomer"> {{ customers.apt_no}} </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span> Update  </h6>

  <h6 class="custom-maintitle mb-2"><b>Update Apartment Details:{{ customers.apt_no }}</b></h6>





<div class="card mt-1">
<div class="card-body">

    <div class="row">
  <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Apt. No / Homeowner</label>
            <input v-model="customers.apt_no" style="font-size: small;" class="form-control" disabled >
    </div>
  </div>
  <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Name of Homeowner</label>
            <input v-model="customers.C_name"  style="font-size: small;" class="form-control" >
    </div>
  </div>
  <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Apt Phone</label>
            <input v-model="customers.C_contact_tel1" style="font-size: small;" class="form-control" >
    </div>
  </div>
  <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Address Line 1</label>
            <input  v-model="customers.C_address_line1" style="font-size: small;" class="form-control" >
    </div>
  </div>
  
  

</div>

<div class="row">
  <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Address Line 2</label>
            <input v-model="customers.C_address_line2"  style="font-size: small;" class="form-control" >
    </div>
  </div>
  <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Address Line 3</label>
            <input  v-model="customers.C_address_line3" style="font-size: small;" class="form-control" >
    </div>
  </div>
  <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Service charge/ Sinking fund</label>
            <input v-model="customers.billing_type"  style="font-size: small;" class="form-control" >
    </div>
  </div>



  </div>

<br>



    <h6 class="purchitem mb-2"><b>Homeowner Contact</b></h6>
    <div class="table-responsive">
      <table style="font-size: small; " class="table table-striped table-sm table-hover ">
        <thead>
          <tr>
           
                <th>   
                  <div class="form-group custom-form ">
                    <label class="custom-label">Name</label>
                  </div>
                </th>
                <th>
                  <div class="form-group custom-form ">
                    <label class="custom-label">Email</label>
                  </div>
                </th>
                <th>
                  <div class="form-group custom-form ">
                    <label class="custom-label">Tel.</label>
                  </div>
                </th>
                <th>
                  <div class="form-group custom-form ">
                    <label class="custom-label ">Actions</label>
                  </div>
                </th>
                
                
              
              
            </tr>
          </thead>
          <tbody>
            <tr v-for="(customer_contact, index) in customer_contacts" :key="customer_contact.id">
             
              <td>{{customer_contact.name}} </td>
              <td>{{customer_contact.email }}</td>
              <td>{{customer_contact.tel }}</td>
              <td class="width-custom5">
                <button   class="btn me-1 custom-btn btn-primary btn-sm mb-1 font-size_def">Inactive</button>
                <button @click="contactUpdate(customer_contact.id)" class="btn custom-btn btn-primary btn-sm mb-1 font-size_def"> Update</button>
              </td>
             
              
              
            </tr>
           
           



          
            
          </tbody>


        </table>
       
    </div>
    <h6 class="purchitem mb-2"><b>Add New Homeowner Contact</b></h6>

    <div class="table-responsive">
      <table style="font-size: small; " class="table table-striped table-sm table-hover ">
        <thead>
          <tr>
           
                <th>   
                  <div class="form-group custom-form ">
                    <label class="custom-label"> Contact Name</label>
                  </div>
                </th>
                <th>
                  <div class="form-group custom-form ">
                    <label class="custom-label"> Email</label>
                  </div>
                </th>
                <th>
                  <div class="form-group custom-form ">
                    <label class="custom-label"> Mobile No</label>
                  </div>
                </th>
               
                
              
                <th></th>  
            </tr>
          </thead>
            <tbody>
                <tr>
                    <td><input type="text" v-model="contact_create[0].name" style="font-size: small;" class="form-control" ></td>
                    <td><input type="email"  v-model="contact_create[0].email" style="font-size: small;" class="form-control" ></td>
                    <td><input type="number"  v-model="contact_create[0].tel" style="font-size: small;" class="form-control" ></td>
                    <td class="custom-icon">  <b-icon @click="add" class="ms-2 mt-2"  width="8" type="button" icon="plus-lg" scale="2" variant=""></b-icon></td>
                </tr>
                <tr v-for="key in count" :key="key">
                    <td><input type="text"  v-model="contact_create[key].name" style="font-size: small;" class="form-control" ></td>
                    <td><input type="email" v-model="contact_create[key].email" style="font-size: small;" class="form-control" ></td>
                    <td><input type="number" v-model="contact_create[key].tel" style="font-size: small;" class="form-control" ></td>
                   
                    <td class="custom-icon"> 
                    <b-icon @click="remove" class="ms-2 mt-2"  width="8" type="button" icon="dash-lg" scale="2" variant=""></b-icon>
                     <b-icon @click="add" class="ms-3 mt-2"  width="8" type="button" icon="plus-lg" scale="2" variant=""></b-icon>
                 </td>
                </tr>
            </tbody>
          </table>
          </div>

<br>
    <h6 class="purchitem mb-2"><b>Tenant Contact List</b></h6>
    <div class="table-responsive">
      <table style="font-size: small; " class="table table-striped table-sm table-hover ">
        <thead>
          <tr>
           
                <th>   
                  <div class="form-group custom-form ">
                    <label class="custom-label">Name</label>
                  </div>
                </th>
                <th>
                  <div class="form-group custom-form ">
                    <label class="custom-label">Email</label>
                  </div>
                </th>
                <th>
                  <div class="form-group custom-form ">
                    <label class="custom-label">Tel.</label>
                  </div>
                </th>
                <th>
                  <div class="form-group custom-form ">
                    <label class="custom-label ">Actions</label>
                  </div>
                </th>
                
                
              
              
            </tr>
          </thead>
          <tbody>
            <tr v-for="(tenant, index) in tenants" :key="tenant.id">
             
              <td>{{tenant.tenant_name}} </td>
              <td>{{ }}</td>
              <td>{{tenant.contact }}</td>
              <td class="width-custom5">
                <button   class="btn me-1 custom-btn btn-primary btn-sm mb-1 font-size_def">Inactive</button>
                <button @click="tenantUpdate(tenant.id)"  class="btn custom-btn btn-primary btn-sm mb-1 font-size_def"> Update</button>
              </td>
             
              
              
            </tr>
           
           



          
            
          </tbody>


        </table>
       
    </div>

    <h6 class="purchitem mb-1"><b>Add New Tenant Contact</b></h6>
    <div class="table-responsive">
      <table style="font-size: small; " class="table table-striped table-sm table-hover ">
        <thead>
          <tr>
           
                <th>   
                  <div class="form-group custom-form ">
                    <label class="custom-label"> Contact Name</label>
                  </div>
                </th>
                <th>
                  <div class="form-group custom-form ">
                    <label class="custom-label"> Email</label>
                  </div>
                </th>
                <th>
                  <div class="form-group custom-form ">
                    <label class="custom-label"> Mobile No</label>
                  </div>
                </th>
               
                
              
                <th></th>  
            </tr>
          </thead>
            <tbody>
                <tr>
                    <td><input type="text" v-model="tenant_create[0].tenant_name" style="font-size: small;" class="form-control" ></td>
                    <td><input type="email" v-model="tenant_create[0].email" style="font-size: small;" class="form-control" ></td>
                    <td><input type="number" v-model="tenant_create[0].contact" style="font-size: small;" class="form-control" ></td>
                    <td class="custom-icon">  <b-icon @click="add1" class="ms-2 mt-2"  width="8" type="button" icon="plus-lg" scale="2" variant=""></b-icon></td>
                </tr>
                <tr v-for="key in count1" :key="key">
                    <td><input type="text" v-model="tenant_create[key].tenant_name" style="font-size: small;" class="form-control" ></td>
                    <td><input type="email" v-model="tenant_create[key].email" style="font-size: small;" class="form-control" ></td>
                    <td><input type="number" v-model="tenant_create[key].contact" style="font-size: small;" class="form-control" ></td>
                   
                    <td class="custom-icon"> 
                    <b-icon @click="remove1" class="ms-2 mt-2"  width="8" type="button" icon="dash-lg" scale="2" variant=""></b-icon>
                     <b-icon @click="add1" class="ms-3 mt-2"  width="8" type="button" icon="plus-lg" scale="2" variant=""></b-icon>
                 </td>
                </tr>
            </tbody>
          </table>
          </div>


    
<br>
    <h6 class="purchitem mb-1"><b>Occupants</b></h6>
   
    <div class="table-responsive">
      <table style="font-size: small; " class="table table-striped table-sm table-hover ">
        
          <tbody>
            <tr>
              <td class="width-custom2"><b>Number of Occupants </b></td>
             <td>{{ customers.C_occupants}}</td> 
             <td class="width-custom6" >
                <button  @click="occupantsUpdate(customers.idCustomer)"   class=" btn custom-btn btn-primary btn-sm ">Update</button>
            </td> 
            </tr>
           
           



          
            
          </tbody>


        </table>
       
    </div>
    
    




<div   class="d-grid gap-2 d-md-flex justify-content-md-end mt-4 mb-5">
<button v-on:click="Update(customers.idCustomer)"    class=" btn custom-btn btn-primary btn-sm mb-1"> Save</button>
</div>


</div>
</div>
</div>









</div>






        
        <content-footer></content-footer>
    </div>
</template>
<script>
 import axios from 'axios';
 import authService from '@/auth.service';
  import TopNavbar from './../../layout/TopNavbar.vue'
  import ContentFooter from './../../layout/ContentFooter.vue'

  export default {
    data() {
      return {
        access_token:authService.isLoggedIn(),
        userid:authService.isUserid(),
       
        'idCustomer':this.$route.query.id,
        
        customers:{},
        customer_contacts:[],
        contact_create:[
            {},
        ],
        tenant_create:[
            {},
        ],
        tenants:[],
        count:0,
        count1:0,
       
      


        
      }

    },
    mounted(){
 
  this.loadApartment();
    },

    computed: {
    roundToTwoDecimal() {
      return detail => parseFloat(detail).toFixed(2);
    }
  },
methods : {

  
  contactUpdate(id){
    this.$router.push('/contact/update?id='+id);
  },
  tenantUpdate(id){
    this.$router.push('/tenant/update?id='+id);
  },
  occupantsUpdate(id){
    this.$router.push('/occupant/update?id='+id);
  },
      


  
  
  async Update(id) {
    console.log(this.contact_create);
    try {
      const { data} = await  axios.post('/mcustomer/update?id='+id,{userid:this.userid,customers:this.customers,contact_create:this.contact_create,tenant_create:this.tenant_create},{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);

       if(data.status == 200){
        this.$router.push('/aparment/view?id='+id);
       }
     
      
    } catch (error) {
      console.log(error.response);
    }
  },
  async loadApartment() {
    console.log(this.idCustomer);
    try {
      const { data} = await  axios.get('/mcustomer/view?id='+this.idCustomer,{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       this.customers = data.customer;
       this.customer_contacts = data.customer_contact;
       this.tenants = data.tenant;
      
    } catch (error) {
      console.log(error.response);
    }
  },

  add: function(){
            this.count++;
            this.contact_create.push(
                {},
                )
           
        },

  remove: function () {
            this.count--;
            this.contact_create.splice(
                {},1
                )
            
            
        },
  add1: function(){
            this.count1++;
            this.tenant_create.push(
                {},
                )
           
        },

  remove1: function () {
            this.count1--;
            this.tenant_create.splice(
                {},1
                )
            
        },




},

    components :{
        ContentFooter,
        TopNavbar
    },
  }

</script>
<style >

</style>